import { UserRolePermissions } from '@/common/interface/user.role.permission';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {

  constructor(private httpClient: HttpClient, private router: Router, private toastr: ToastrService) {

  }
  //api url
  private apiUrl = environment.apiUrl;
  addUserRolePermissions(userRolePermissions: UserRolePermissions): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/UserRolePermission/AddUserRolePermissions`, userRolePermissions).pipe(
      //catchError(this.error)
    );
  }
  updateUserRole(userRolePermissions: any): Observable<any>{
    return this.httpClient.post(`${this.apiUrl}/UserRolePermission/UpdateUserRolePermission`, userRolePermissions).pipe(
      //catchError(this.error)
    );
    
  }
  getPermissioList(): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/UserRolePermission/GetPermissionsList`).pipe(
      //catchError(this.error)
    );;
  }
  getRolePermissioListByRoleId(roleId: number): Observable<any> {
    console.log("7",roleId);
    return this.httpClient.get(`${this.apiUrl}/UserRolePermission/GetUserRolePermissionsByRoleId?roleId=${roleId}`).pipe(
      //catchError(this.error)
    );;
  }
  getSectionList(): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/UserRolePermission/GetSectionsList`).pipe(
      //catchError(this.error)
    );;
  }
  getRoleList(): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/UserRolePermission/UserRoleList`).pipe(
      //catchError(this.error)
    );;
  }
  getUserlistCount(userId:any): Observable<any>{
    return this.httpClient.get(`${this.apiUrl}/UserRolePermission/UserRoleListWithUserCount?userId=${userId}`).pipe();
  }
}
